import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { isNull } from 'lodash';
import {
  REQUEST_EXISTANT_CLAIMS,
  REQUEST_VALIDATE_EXISTING_CLAIM__DOCUMENTS,
} from 'containers/ManagerDocumentsPage/constants';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { setExistantClaims } from 'containers/ManagerDocumentsPage/actions';
import { Document } from 'containers/ManagerDocumentsPage/typings';

export function* getExistantClaims(action: any) {
  const { page, pageSize, status } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/existant-claim/documents/${status}?page=${page}&pageSize=${pageSize}`;
  if (isNull(token)) return;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setExistantClaims);
}

export function* getExistantClaimsSaga() {
  yield takeLeading(REQUEST_EXISTANT_CLAIMS, getExistantClaims);
}

export function* validateDocuments(action: {
  type: string;
  documents: Document[];
}) {
  const { documents } = action;
  const token = accessTokenStorage.get().token;
  if (isNull(token)) return;
  const path = `/corporeal/existant-claim/validate-documents`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ documents }),
  };

  yield callApi(path, {}, options, [], setExistantClaims);
}

export function* validateDocumentsSaga() {
  yield takeLeading(
    REQUEST_VALIDATE_EXISTING_CLAIM__DOCUMENTS,
    validateDocuments,
  );
}

export default [getExistantClaimsSaga, validateDocumentsSaga];
